import { render, staticRenderFns } from "./UsaToday.vue?vue&type=template&id=a06a8d5e&"
import script from "./UsaToday.vue?vue&type=script&lang=js&"
export * from "./UsaToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports